const BASE_ROUTE = '/stats';

export const STATS_ROUTES = {
  stats: BASE_ROUTE,
  products: `${BASE_ROUTE}/products`,
  payments: `${BASE_ROUTE}/payments`,
  acquisition: `${BASE_ROUTE}/acquisition`,
  shipping: `${BASE_ROUTE}/shipping`,
  nubeinsightsLiveview: `${BASE_ROUTE}/v2/liveview`,
  nubeinsightsGeneral: `${BASE_ROUTE}/v2/general`,
  nubeinsightsCoupons: `${BASE_ROUTE}/v2/coupons`,
  nubeinsightsSearchInsights: `${BASE_ROUTE}/v2/search-insights`,
  nubeinsightsVisits: `${BASE_ROUTE}/v2/visits`,
  nubeinsightsSales: `${BASE_ROUTE}/v2/sales`,
  nubeinsightsProducts: `${BASE_ROUTE}/v2/products`,
};
